import React, { useCallback, useEffect, useState } from "react";

import "./style.scss";

import closeIcon from "../../assets/images/close-icon.png";

interface Props {
  visible: boolean;
  style?: React.CSSProperties;
  layerStyle?: React.CSSProperties;
  closeStyle?: React.CSSProperties;
  rootStyle?: React.CSSProperties;
  children?: React.ReactNode;
  onCancel: () => void;
  keepAlive?: boolean;
  layerClose?: boolean;
  closeable?: boolean;
  ghost?: boolean;
  onClick?: () => void;
}

const dialogShowIndex = 100;

// 页面级
const Dialog: React.FC<Props> = (props: Props) => {
  const {
    visible,
    style,
    layerStyle,
    closeStyle,
    rootStyle,
    onCancel = () => {},
    children,
    keepAlive = false,
    layerClose = true,
    closeable = true,
    ghost = false,
    onClick = () => {},
  } = props;
  const [show, setShow] = useState(false);
  const [zIndex, setZIndex] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setShow(visible);
    });
  }, [visible]);

  useEffect(() => {
    if (show) {
      const allDialogRoot: any = document.querySelectorAll(".dialog-root");
      const dialogNum = allDialogRoot.length;
      const num = dialogNum > 1 ? 0 : 1;
      setZIndex(dialogShowIndex + dialogNum - num);
    }
  }, [show]);

  const getStyle = useCallback(() => {
    return show ? { zIndex, ...style } : style;
  }, [show, style, zIndex]);

  return keepAlive || visible ? (
    <div className="dialog-root" style={rootStyle} onClick={onClick}>
      <div
        className={`dialog ${show ? "dialog--show" : ""}`}
        style={
          ghost ? { background: "transparent", ...getStyle() } : getStyle()
        }
      >
        {closeable && (
          <img
            style={closeStyle}
            className="close-icon"
            src={closeIcon}
            onClick={() => {
              closeable && onCancel();
            }}
          />
        )}
        {children}
      </div>
      <div
        style={show ? { zIndex: zIndex - 1, ...layerStyle } : layerStyle}
        className={`dialog-layer ${show ? "dialog-layer--show" : ""}`}
        onClick={() => {
          layerClose && onCancel();
        }}
      ></div>
    </div>
  ) : (
    <></>
  );
};

export default Dialog;
